import styled from "@emotion/styled";

import { colors } from "../../colors";

export const AppName = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: ${colors.gray[700]};
  line-height: 1.4;
  margin-bottom: 4px;
`;

export const AppVersion = styled.div`
  color: ${colors.gray[500]};
  line-height: 1.4;
  font-weight: 600;
`;

export const NavigationSection = styled.nav`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 300px);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.gray[300]};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.gray[400]};
  }
`;
